import { Inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICON_TOKEN } from '../constants/icon.token';
import { Icon } from '../types/icon.type';

@Injectable()
export class IconService {
  constructor(private registry: MatIconRegistry, private sanitizer: DomSanitizer, @Inject(ICON_TOKEN) icons: Icon[]) {
    icons.forEach(item => {
      const icon: Icon = { key: '', path: '' };
      if (typeof item === 'string') {
        icon.key = item;
        icon.path = `assets/mat-icons/${item}.svg`;
        this.registerIcon(icon);
      } else {
        if (item.isSvg) this.registerIcon(item);
      }
    });
  }

  private registerIcon(icon: Icon): void {
    if (typeof icon !== 'string' && icon.key && icon.path) {
      this.registry.addSvgIcon(icon.key, this.sanitizer.bypassSecurityTrustResourceUrl(icon.path));
    }
  }
}
